/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import { useEffect, useState } from "react";
import useAPIHandler from "../../../../hook/use-api-handler";
import { logger } from "../../../../utils/logger";
import { LEAVE_INFORMATION_INITIAL } from "./leave-information-constant";

const useLeaveFormationService = ({ openSnackbar }) => {
    const [leaveInformationLists, setLeaveInformationLists] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
    const [leaveListsInfo, setLeaveListsInfo] = useState([]);

    const [leaveRequests, setLeaveRequests] = useState(LEAVE_INFORMATION_INITIAL)

    const { fetchData } = useAPIHandler();

    useEffect(() => {
        getLeaveInfomationLists();
    }, [rowsPerPage, currentPage, searchQuery]);

    const getLeaveInfomationLists = async () => {
        try {
            const URL = `/employee/leave-info?page=${currentPage + 1}&pageSize=${rowsPerPage}&search=${searchQuery}`;
            const METHOD = "GET";

            const result = await fetchData({ url: URL, method: METHOD });

            setLeaveInformationLists(result?.data?.leaveInfo || []);
            const totalPageCount = result?.data?.pagination?.totalPages || 1;
            setTotalPages(totalPageCount);
        } catch (error) {
            logger.log(error);
            openSnackbar({ message: "Error fetching leave information", color: "danger" });
        }
    };

    const handleNextPage = () => {
        setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages - 1));
    };

    const handlePreviousPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
    };

    const handleRowsPerPageChange = (value) => {
        setRowsPerPage(Number(value.target.value));
        setCurrentPage(0);
    };

    const handleAddRow = () => {
        setLeaveRequests([...leaveRequests, { leave_type_id: "", start_date: "", end_date: "" }]);
      };
      
      const handleDeleteRow = (index) => {
        const updatedList = leaveRequests.filter((_, i) => i !== index);
        setLeaveRequests(updatedList);
      };
      
      const handleChange = (index, field, value) => {
        const updatedList = [...leaveRequests];
        updatedList[index][field] = value;
        setLeaveRequests(updatedList);
      };

      const submitApplyLeave = async (leaveRequests, empId) => {
        try {
            const URL = `/employee/apply-leave/${empId}`;
            const METHOD = "POST";
            const result = await fetchData({ 
                url: URL, 
                method: METHOD, 
                data: { apply_leave: leaveRequests } 
            });
    
            if (result.status === "success") {
                setLeaveRequests(LEAVE_INFORMATION_INITIAL)
                openSnackbar({ message: "Leave successfully applied.", color: "success" });
                getLeaveInfomationLists()
                return true;
            } else {
                openSnackbar({ message: "Failed to apply leave.", color: "error" });
                return true;
            }
        } catch (error) {
            handleAPIError(error);
            return true;
        }
    };


      const handleAPIError = (error) => {
        if (error?.type === "JoiValidationError") {
            const errorsAll = error.errors.reduce((acc, curr) => {
                acc[curr.field] = curr.message;
                return acc;
            }, {});

            openSnackbar({
                message: Object.keys(errorsAll).length > 0 ? "Validation Error!" : "Something went wrong!",
                color: "danger",
            });
        } else {
            const backendMessage = typeof error.message === "string" ? error.message : "An unexpected error occurred.";
            openSnackbar({ message: backendMessage, color: "danger" });
        }

        logger.log(error);
    };

    const getEmployeeLeaveInformation = async (id) => {
        try {
            const leaveTypes = [];
            const URL = `/employee/leave-info/${id}`;
            const METHOD = "GET";
    
            const result = await fetchData({ url: URL, method: METHOD });
            
            const employeeData = result.data[0];
    
            const leaveBalances = employeeData.leave_balances?.reduce((acc, balance) => {
                const leaveType = balance.leave_types.leave_type_name;
                const usedLeaves = parseInt(balance.leaves + balance.cf_leaves, 10) || 0;
    
                if (!acc[leaveType]) {
                    leaveTypes.push(leaveType)
                    acc[leaveType] = 0;
                }
                acc[leaveType] += usedLeaves;
    
                return acc;
            }, {});

            const usedLeaveSummary = employeeData.used_leave?.map(monthData => {
                const monthSummary = { month: monthData.month };
    
                monthData.leaveType.forEach(leave => {
                    const leaveTypeName = leave.leave_type_name;
                    const leaveCount = parseInt(leave.leave, 10) || 0;
    
                    monthSummary[leaveTypeName] = (monthSummary[leaveTypeName] || 0) + leaveCount;
                });
    
                return monthSummary;
            });
    
            return { ...employeeData, leaveBalances, usedLeaveSummary,leaveTypes };
        } catch (error) {
            logger.log(error);
            openSnackbar({ message: "Error fetching employee leave information", color: "danger" });
            return null; // Return null in case of error
        }
    };
    
    const EmployeeLeaveLists = async (empType) => {
        try {
            const URL = `/organization/leave-policy?for_emp=${empType}`;
            const METHOD = "GET";

            const result = await fetchData({ url: URL, method: METHOD });

            const transformedLeaveLists = result?.data?.orgLeavePolicy.map(policy => ({
                id: policy.leave_types.leave_type_id,
                name: policy.leave_types.leave_type_name
            })) || [];
            setLeaveListsInfo(transformedLeaveLists);
        } catch (error) {
            logger.log(error);
            openSnackbar({ message: "Error fetching leave policies", color: "danger" });
        }
    };

    const today = new Date();
    const firstDayOfMonth = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-01`;
    const firstDayOfPreviousMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const formattedFirstDayOfPreviousMonth = `${firstDayOfPreviousMonth.getFullYear()}-${String(firstDayOfPreviousMonth.getMonth() + 1).padStart(2, '0')}-01`;



    return {
        leaveInformationLists,
        rowsPerPage,
        currentPage,
        totalPages,
        handleNextPage,
        handlePreviousPage,
        handleRowsPerPageChange,
        searchQuery,
        setSearchQuery,
        handleAddRow,
        handleDeleteRow,
        handleChange,
        leaveRequests,
        submitApplyLeave,
        getEmployeeLeaveInformation,
        setLeaveRequests,
        leaveListsInfo,
        EmployeeLeaveLists,
        firstDayOfMonth,
        formattedFirstDayOfPreviousMonth
    };
};

export default useLeaveFormationService;
